/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	var cutTheMustard = __webpack_require__(7)
	
	void (function() {
	
	  if (!cutTheMustard()) {
	    return
	  }
	
	  var components = (function(lib, modules) {
	    modules.forEach(function(module) {
	        lib[module] = __webpack_require__(9)("./" + module.toLowerCase())
	    })
	
	    return lib
	  })({}, ['Fiddle', 'Example', 'Notifications', 'Autocomplete'])
	
	  Array.prototype.forEach.call(document.querySelectorAll('[data-component]'), function(el) {
	    el.getAttribute('data-component').split(' ').forEach(function(component) {
	      components[component] && new components[component](el)
	    })
	  })
	
	})()


/***/ },
/* 1 */
/***/ function(module, exports) {

	// Adapted from <https://github.com/vkiryukhin/pretty-data>
	
	function createShiftArray(depth) {
	  var shift = ['\n']
	  var indent = '  '
	  var i
	
	  for (i = 0; i < depth; i++) {
	    shift.push(shift[i] + indent)
	  }
	
	  return shift
	}
	
	function createSourceArray(text) {
	  return text.replace(/>\s{0,}</g, '><')
	    .replace(/</g, '~::~<')
	    .replace(/xmlns\:/g, '~::~xmlns:')
	    .replace(/xmlns\=/g, '~::~xmlns=')
	    .split('~::~')
	}
	
	module.exports = function formatXML(text) {
	  var source = createSourceArray(text)
	  var shift = createShiftArray(100)
	  var inComment = false
	  var result = ''
	  var depth = 0
	  var i, len
	
	  for (i = 0, len = source.length; i < len; i++) {
	
	    // start comment or <![CDATA[...]]> or <!DOCTYPE
	    if (source[i].search(/<!/) > -1) {
	      result += shift[depth] + source[i]
	      inComment = true
	
	      // end comment  or <![CDATA[...]]>
	      if (source[i].search(/-->/) > -1 || source[i].search(/\]>/) > -1 || source[i].search(/!DOCTYPE/) > -1) {
	        inComment = false
	      }
	
	      continue
	    }
	
	    // end comment  or <![CDATA[...]]>
	    if (source[i].search(/-->/) > -1 || source[i].search(/\]>/) > -1) {
	      result += source[i]
	      inComment = false
	      continue
	    }
	
	    // <elm></elm>
	    if (/^<\w/.exec(source[i - 1]) && /^<\/\w/.exec(source[i]) &&
	      /^<[\w:\-\.\,]+/.exec(source[i - 1]) == /^<\/[\w:\-\.\,]+/.exec(source[i])[0].replace('/', '')) {
	      result += source[i]
	
	      if (!inComment) {
	        depth--
	      }
	
	      continue
	    }
	
	    // <elm>
	    if (source[i].search(/<\w/) > -1 && source[i].search(/<\//) == -1 && source[i].search(/\/>/) == -1) {
	      result = !inComment ? result += shift[depth++] + source[i] : result += source[i]
	      continue
	    }
	
	    // <elm>...</elm>
	    if (source[i].search(/<\w/) > -1 && source[i].search(/<\//) > -1) {
	      result = !inComment ? result += shift[depth] + source[i] : result += source[i]
	      continue
	    }
	
	    // </elm>
	    if (source[i].search(/<\//) > -1) {
	      result = !inComment ? result += shift[--depth] + source[i] : result += source[i]
	      continue
	    }
	
	    // <elm/>
	    if (source[i].search(/\/>/) > -1) {
	      result = !inComment ? result += shift[depth] + source[i] : result += source[i]
	      continue
	    }
	
	    // <? xml ... ?>
	    if (source[i].search(/<\?/) > -1) {
	      result += shift[depth] + source[i]
	      continue
	    }
	
	    // xmlns
	    if (source[i].search(/xmlns\:/) > -1 || source[i].search(/xmlns\=/) > -1) {
	      result += shift[depth] + source[i]
	      continue
	    }
	
	    result += source[i]
	  }
	
	  return result[0] == '\n' ? result.slice(1) : result
	}


/***/ },
/* 2 */
/***/ function(module, exports) {

	// Adapted from <https://gist.github.com/gaohailang/5291190>
	
	module.exports = (function(l, u, r, i) {
	  return function(n, f) {
	    r = l[n] = l[n] || [], i = -1
	    if (f && f.call) {
	      r.push(f)
	    } else {
	      while (r[++i]) {
	        r[i].call(u, f)
	      }
	    }
	  }
	})({})


/***/ },
/* 3 */
/***/ function(module, exports) {

	var SELF_CLOSING = /\/$/
	var PREVIOUS_TAG = /([^<]+\/?)$/
	var TAG_NAME = /^([a-z-:]+)/i
	var WHITESPACE_INDENT = /^(\s*)/
	var CURRENT_LINE = /(^|[\n\r])(.+)$/
	
	function insertClosingQuote(string, position, newChar) {
	  var prevChar = this.prevCharacter(string, position)
	  var nextChar = this.nextCharacter(string, position)
	
	  if (newChar != prevChar && newChar != nextChar) {
	    this.insertAfter(string, position, newChar)
	  }
	}
	
	function insertClosingTag(string, position) {
	  var prevTag = string.slice(0, position).match(PREVIOUS_TAG)
	
	  if (prevTag && !SELF_CLOSING.test(prevTag[1])) {
	    var tagName = prevTag[1].match(TAG_NAME)
	
	    if (tagName) {
	      this.insertAfter(string, position, '</' + tagName.pop() + '>')
	    }
	  }
	}
	
	function indentNewLine(string, position) {
	  var nextChar = this.nextCharacter(string, position)
	  var currentLine = string.slice(0, position).match(CURRENT_LINE)
	
	  if (currentLine) {
	    var indent = '\n' + currentLine.pop().match(WHITESPACE_INDENT).pop()
	
	    if (nextChar == '<') {
	      string = this.insert(string, position, indent)
	    }
	
	    this.insertBefore(string, position, indent)
	  }
	}
	
	function insertTab(string, position) {
	  this.insertBefore(string, position, '\t')
	}
	
	function Autocomplete(target) {
	  this.el = target
	  this.el.onkeypress = this.onKeypress.bind(this)
	  this.el.onkeydown = this.onKeydown.bind(this)
	}
	
	Autocomplete.prototype.onKeypress = function(e) {
	  var args = [ this.el.value, this.el.selectionStart, String.fromCharCode(e.charCode) ]
	
	  switch (e.charCode) {
	    case 34:
	    case 39:
	      insertClosingQuote.apply(this, args)
	      break
	    case 62:
	      insertClosingTag.apply(this, args)
	      break
	  }
	}
	
	Autocomplete.prototype.onKeydown = function(e) {
	  var args = [ this.el.value, this.el.selectionStart ]
	  var preventDefault = true
	
	  switch (e.keyCode) {
	    case 13:
	      indentNewLine.apply(this, args)
	      break
	    case 9:
	      insertTab.apply(this, args)
	      break
	    default:
	      preventDefault = false
	  }
	
	  preventDefault && e.preventDefault()
	}
	
	Autocomplete.prototype.prevCharacter = function(string, position) {
	  return string.slice(position - 1, position)
	}
	
	Autocomplete.prototype.nextCharacter = function(string, position) {
	  return string.slice(position, position + 1)
	}
	
	Autocomplete.prototype.insert = function(string, position, content) {
	  return [string.slice(0, position), content, string.slice(position)].join('')
	}
	
	Autocomplete.prototype.insertBefore = function(string, position, content) {
	  var caretPosition = position + content.length
	  this.el.value = this.insert.apply(this, arguments)
	  this.el.setSelectionRange(caretPosition, caretPosition)
	}
	
	Autocomplete.prototype.insertAfter = function(string, position, content) {
	  this.el.value = this.insert.apply(this, arguments)
	  this.el.setSelectionRange(position, position)
	}
	
	module.exports = Autocomplete


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var formatXML = __webpack_require__(1)
	
	function Example(target) {
	  if (target.value) {
	    return
	  }
	
	  var snippet = document.querySelector(target.getAttribute('data-element-snippet'))
	  target.value = formatXML(snippet.innerHTML.trim())
	}
	
	module.exports = Example


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var XSLT = __webpack_require__(10)
	var pubsub = __webpack_require__(2)
	
	function Fiddle(target) {
	  this.xslt = new XSLT
	
	  this.el = {
	    type: document.querySelector(target.getAttribute('data-element-type')),
	    xml: document.querySelector(target.getAttribute('data-element-xml')),
	    xsl: document.querySelector(target.getAttribute('data-element-xsl')),
	    output: document.querySelector(target.getAttribute('data-element-output'))
	  }
	
	  target.onsubmit = this.onSubmit.bind(this)
	}
	
	Fiddle.prototype.onSubmit = function(e) {
	  e.preventDefault()
	
	  try {
	    this.xslt.source(this.el.xml.value, this.el.type.value == 'HTML').stylesheet(this.el.xsl.value)
	  } catch(err) {
	    return pubsub('error', err.message)
	  }
	
	  this.el.output.value = this.xslt.transform()
	  pubsub('success', 'Transform successful')
	}
	
	module.exports = Fiddle


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var pubsub = __webpack_require__(2)
	
	function Notice(type, message) {
	  this.el = document.createElement('p')
	  this.el.classList.add('Notice', 'Notice--' + type)
	  this.el.innerHTML = message
	}
	
	Notice.prototype.appendTo = function(target) {
	  target.appendChild(this.el)
	  return this
	}
	
	Notice.prototype.remove = function() {
	  this.el.parentNode.removeChild(this.el)
	  return this
	}
	
	function Notifications(target) {
	  this.target = target
	  this.stack = []
	
	  pubsub('error', this.error.bind(this))
	  pubsub('warning', this.warning.bind(this))
	  pubsub('success', this.success.bind(this))
	}
	
	Notifications.prototype.add = function(type, message) {
	  var notice = this.stack.push(new Notice(type, message).appendTo(this.target))
	  setTimeout(this.remove.bind(this, this.stack[notice - 1]), 5000)
	}
	
	Notifications.prototype.error = function(message) {
	  this.add('error', message)
	}
	
	Notifications.prototype.warning = function(message) {
	  this.add('warning', message)
	}
	
	Notifications.prototype.success = function(message) {
	  this.add('success', message)
	}
	
	Notifications.prototype.remove = function(notice) {
	  this.stack.splice(this.stack.indexOf(notice), 1)[0].remove()
	}
	
	module.exports = Notifications


/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = function cutTheMustard() {
	
	  var requirements = [
	    {
	      title: 'the selectors API',
	      test: document.querySelector
	    },
	    {
	      title: 'DOM level 2 events',
	      test: window.addEventListener
	    },
	    {
	      title: 'the web storage API',
	      test: window.localStorage
	    },
	    {
	      title: 'DOM parsing and serialization APIs',
	      test: window.XMLSerializer
	    },
	    {
	      title: 'XSL Transformations',
	      test: window.XSLTProcessor
	    },
	    {
	      title: 'ES5 array extras',
	      test: Array.isArray
	    }
	  ]
	
	  var i, len
	
	  for (i = 0, len = requirements.length; i < len; i++) {
	    if (!requirements[i].test) {
	      alert('Your browser does not support ' + requirements[i].title + ' so this application is unable to run.')
	      return false
	    }
	  }
	
	  return true
	}

/***/ },
/* 8 */
/***/ function(module, exports) {

	var domParser = new DOMParser
	
	module.exports = function parseXML(input, html) {
	  var type = html ? 'text/html' : 'text/xml'
	  var output = domParser.parseFromString(input, type)
	
	  if (output.querySelector('parsererror')) {
	    return new Error('Could not parse ' + type + ' input')
	  }
	
	  return output
	}


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./autocomplete": 3,
		"./autocomplete.js": 3,
		"./example": 4,
		"./example.js": 4,
		"./fiddle": 5,
		"./fiddle.js": 5,
		"./notifications": 6,
		"./notifications.js": 6
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 9;


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var parseXML = __webpack_require__(8)
	var formatXML = __webpack_require__(1)
	
	var processor = new XSLTProcessor
	var serializer = new XMLSerializer
	
	function XSLT() {
	  this.sourceTree = null
	  this.stylesheetTree = null
	}
	
	XSLT.prototype.source = function(input, html) {
	  this.sourceTree = parseXML.apply(null, arguments)
	
	  if (this.sourceTree instanceof Error) {
	    throw new Error('Failed to parse the XML source')
	  }
	
	  return this
	}
	
	XSLT.prototype.stylesheet = function(input) {
	  this.stylesheetTree = parseXML.apply(null, arguments)
	
	  if (this.stylesheetTree instanceof Error) {
	    throw new Error('Failed to parse the stylesheet')
	  }
	
	  return this
	}
	
	XSLT.prototype.transform = function() {
	  var fragment = document.implementation.createDocument('', '', null)
	
	  processor.reset()
	  processor.importStylesheet(this.stylesheetTree)
	
	  var result = processor.transformToFragment(this.sourceTree, fragment)
	
	  return formatXML(serializer.serializeToString(result))
	}
	
	module.exports = XSLT


/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** bundle.js
 **/